module.exports = __webpack_public_path__ + "static/media/(V)_MG_4786_-_Pro-Natura_-_Moda_Feminina.61340607.jpg";